<template>
  <div class="main-content">
    <div class="search-panel">
      <div class="search-filter-simple__component">
        <el-row class="filter-component__label">简历下载日期</el-row>
        <el-row>
          <el-select v-model="queryData.resumeDownloadTime" placeholder="请选择">
            <el-option v-for="item in resumeDownloadTimeList" :key="item.id" :label="item.text" :value="item.id">
            </el-option>
          </el-select>
        </el-row>
      </div>      
    </div>
    <div class="talent-search__button">
      <el-button type="primary" style="padding: 10px 39px;" icon="el-icon-search" @click="onSearch">搜索</el-button>
      <el-button style="margin-left:24px;" type="text" icon="el-icon-brush" class="icoRotate180" @click="onClear">清空搜索条件
      </el-button>
    </div>
    <div class="talent-search__candition">
      <div class="divider"></div>
      <span style="display: inline-block; margin-top:12px; font-size: 14px;">搜索条件：</span>
      <el-tag v-for="query in queryDict" :key="query.key" size="medium" closable @close="onCloseTag(query.key)">
        <span class="tag-key">{{query.keyText}}：</span>{{query.valueText}}
      </el-tag>
    </div>
    <el-row class="search-pagination" :class="isfixed ? 'fixed-page':''">
      <el-pagination background @current-change="handleCurrentChange" :current-page="queryData.currentPage"
        :page-sizes="[10]" :page-size="queryData.pageSize" layout="slot, prev, pager, next" :total="total">
        <span class="el-pagination__total">共 {{realTotal > 10000 ? "10000+" : realTotal}}
          条记录</span>
      </el-pagination>
    </el-row>
    <div v-loading="loading" style="margin-bottom: 40px;">
      <div v-for="talent in myDownloadList" :key="talent.meDataId">
        <taCard :talent="talent" :cardType="3" :words="keywords" @goto="onGoto(talent)"></taCard>
      </div>
    </div>
    <dlgInsteadInviteInfo ref="insinvInfo"></dlgInsteadInviteInfo>
  </div>
</template>

<script>
  import {
    resumeRefreshOption
  } from '~/static/commonData';
  import {
    myDownloadResume
  } from '~/api/hr';
  import {
    resumeType2Source
  } from '~/utils';
  import {
    getInsteadInviteInfo
  } from '~/api/insteadInvite';
  import taCard from '../comp_card_long'; 
  import dlgInsteadInviteInfo from '../dlg_insteadInviteInfoTop1';
  export default {
    components: {
      taCard,
      dlgInsteadInviteInfo
    },
    data() {
      return {
        total: 0,
        realTotal: 0,
        resumeDownloadTimeList: [],
        myDownloadList: [],
        queryData: {
          currentPage: 1,
          pageSize: 10,
          resumeDownloadTime: 0,
        },        
        loading: false,
        queryDict: [],
        isfixed: false,        
        keywords: []
      };
    },
    created() {
      this.initPageData();
      this.onClear();
      this.$emit('changeMenu', 'HrDownloadResume');
      this.getList();
    },
    mounted() {
      window.addEventListener('scroll', this.handlePageFix, true);
    },
    beforeRouteLeave(to, from, next) {
      window.removeEventListener('scroll', this.handlePageFix, true);
      next();
    },
    methods: {
      initPageData() {
        this.resumeDownloadTimeList = [{
          text: '不限',
          id: 0
        }];
        resumeRefreshOption.forEach(item => {
          this.resumeDownloadTimeList.push({
            text: item.text,
            id: item.id
          });
        });
      },
      onClear() {
        this.queryData.currentPage = 1;
        this.queryData.resumeDownloadTime = 0;
        this.queryDict = [];
      },
      onSearch() {
        this.queryData.currentPage = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        this.buildQueryDict();
        var params = {
          resumeDownloadTime: this.queryData.resumeDownloadTime,
          pageIndex: this.queryData.currentPage - 1,
          pageSize: this.queryData.pageSize,
        };
        myDownloadResume(params).then((r) => {
          if (r.errcode === 0) {
            var data = r.data;
            this.myDownloadList = data.list;
            this.realTotal = data.total_item_count;
            this.total = this.realTotal > 1000 ? 1000 : this.realTotal;
          } else {
            this.$message.error('获取我的下载人才列表出错，原因：' + r.errmsg);
          }
          this.loading = false;
        }).catch(ex => {
          this.loading = false;
          this.$message.error('获取我的下载人才列表出错，原因：' + ex);
        });
      },
      handlePageFix() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var elItem = document.querySelector('.talent-search__candition');
        var offsetTop = elItem.offsetTop + elItem.clientHeight;
        scrollTop > offsetTop ? this.isfixed = true : this.isfixed = false;
      },
      onGoto(talent) {
        const {
          href
        } = this.$router.resolve({
          path: '/TalentDetail',
          query: {
            id: talent.resumeId,
            type: talent.resumeType,
            isII: talent.isInsteadInvite,
          }
        });
        window.open(href, '_blank');
      },
      onIIInfo(talent) {
        let source = resumeType2Source(talent.resumeType);
        getInsteadInviteInfo({
          resume_source: source,
          resume_id: talent.resumeId
        }).then(r => {
          if (r.errcode == 0) {
            if (r.data != null) { //已设代约:显示代约详情对话框
              this.$refs['insinvInfo'].show(talent, r.data);
            }
          } else {
            this.$message.error('获取人才已有代约出错！原因：' + r.errmsg);
          }
        });
      },
      handleSizeChange(size) {
        this.queryData.pageSize = size;
        this.getList();
      },
      handleCurrentChange(index) {
        this.queryData.currentPage = index;
        this.getList();
      },
      
      buildQueryDict() {
        if (this.queryData.resumeDownloadTime) {
          let resumeDownloadTimeId = this.queryData.resumeDownloadTime;
          let resumeDownloadTime = this.resumeDownloadTimeList.find(c => c.id === resumeDownloadTimeId);
          if (resumeDownloadTime) {
            this.addQueryCondition('resumeDownloadTime', resumeDownloadTimeId, '简历下载时间', resumeDownloadTime.text);
          }
        } else {
          this.removeQuery('resumeDownloadTime');
        }
      },
      addQueryCondition(key, value, keyText, valueText) {
        var index = this.queryDict.findIndex(x => x.key === key);
        if (index < 0) {
          if (value) {
            this.queryDict.push({
              key: key,
              keyText: keyText,
              value: value,
              valueText: valueText
            });
          }
        } else {
          if (!value) {
            this.queryDict.splice(index, 1);
          } else {
            this.queryDict[index].key = key;
            this.queryDict[index].keyText = keyText;
            this.queryDict[index].value = value;
            this.queryDict[index].valueText = valueText;
          }
        }
      },
      onCloseTag(queryKey) {
        switch (queryKey) {
        case 'resumeDownloadTime':{
          this.queryData.resumeDownloadTime = 0;
          break;
        }}
        this.onSearch();
      },
      removeQuery(queryKey) {
        var index = this.queryDict.findIndex(x => x.key === queryKey);
        if (index >= 0) {
          this.queryDict.splice(index, 1);
        }
      },
    },
  };
</script>

<style scoped>
</style>